/*  imported from AnnouncementService.module.scss  */

.AnnouncementService-module__announcement__service___3ZocS {
  padding: 1.5rem;
  text-align: left;
  border-radius: 2px;
  display: flex;
  align-items: flex-start;
}

.AnnouncementService-module__announcement__service__icon___3-ecd {
  flex: none;
  fill: currentColor;
}

.AnnouncementService-module__announcement__service__icon__close___1xZ5J {
  margin: 0.2rem;
  cursor: pointer;
  opacity: 0.6;

  &:hover {
    opacity: 1;
  }
}

.AnnouncementService-module__announcement__service__heading___28rLJ {
  line-height: 1.3;
  padding-bottom: 0.5rem;
  color: inherit;
}

.AnnouncementService-module__announcement__service__message___18omf {
  flex: auto;
  margin-left: 1.5rem;
  margin-right: 1rem;
  color: inherit;
  font-weight: 100;
}

.AnnouncementService-module__announcement__service__link___10g_y {
  color: inherit;
  text-decoration: underline;
}
